import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatButton } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
    selector: 'app-flamingo-alert-dialog',
    template: `
    <div mat-dialog-title>{{ data.title }}</div>
    <div mat-dialog-content>
      <div [innerHTML]="safeHtml"></div>
    </div>
    <div mat-dialog-actions [align]="'end'">
      @if (data.action) {
        <button mat-button [mat-dialog-close]="true" color="warn" class="btn-margin">{{ data.action }}</button>
      }
      <button mat-button [mat-dialog-close]="undefined" color="accent" class="btn-margin">{{ data.confirm }}</button>
    </div>
  `,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        MatDialogTitle,
        MatDialogContent,
        MatDialogActions,
        MatButton,
        MatDialogClose,
    ]
})
export class FlamingoAlertDialogComponent {

  safeHtml: SafeHtml;

  constructor(
    public dialogRef: MatDialogRef<FlamingoAlertDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: FlamingoAlertDialogModel,
    sanitizer: DomSanitizer,
    ) {
    this.safeHtml = sanitizer.bypassSecurityTrustHtml(data.description);
  }

  close(res: boolean): void {
    this.dialogRef.close(res);
  }
}

export interface FlamingoAlertDialogModel {
  title: string;
  description: string;
  confirm: string;
  action?: string;
}
